import styled from 'styled-components';
export const Empty = styled.div<{
  $background: string;
}>`
  background-image: ${({
  $background
}) => $background ? `url(${$background})` : ''};
`;